import kpi from "../../api/kpi";
import kpiHistory from "../../api/kpiHistory";

export default {
  namespaced: true,
  state: {
    items: [],
    statistics: [],
    statisticsSecondPart: [],
    statisticsItems: [],
    customersStatistics: [],
    orderOneStrykerItems: [],
    provisionsItems: [],
    configurationItems: [],
    gimCustomsDistributionItems: [],
    commissions: [],
    totalProjectedPoints: 0,
    loading: false,
    // Historisation
    selectedYear: new Date().getFullYear(),
    selectedMonth: null,
    historizedPeriods: [],
    // Année contractuelle pour le filtre des commandes One
    selectedContractYear: null,
  },
  mutations: {
    setLoading(state, loading) {
      state.loading = loading;
    },
    setItems(state, items) {
      state.items = items;
    },
    setStatistics(state, statistics) {
      state.statistics = statistics;
    },
    setStatisticsItems(state, statisticsItems) {
      state.statisticsItems = statisticsItems;
    },
    setCustomersStatistics(state, customersStatistics) {
      state.customersStatistics = customersStatistics;
    },
    setStatisticsSecondPart(state, statistics) {
      state.statisticsSecondPart = statistics;
    },
    setOrderOneStrykerItems(state, items) {
      state.orderOneStrykerItems = items;
    },
    setProvisionsItems(state, items) {
      state.provisionsItems = items;
    },
    setTotalProjectedPoints(state, totalProjectedPoints) {
      state.totalProjectedPoints = totalProjectedPoints;
    },
    setConfigurationItems(state, items) {
      state.configurationItems = items;
    },
    setGimCustomDistributionItems(state, items) {
      state.gimCustomsDistributionItems = items;
    },
    setCommissions(state, items) {
      state.commissions = items;
    },
    setSelectedYear(state, year) {
      state.selectedYear = year;
    },
    setSelectedMonth(state, month) {
      state.selectedMonth = month;
    },
    setHistorizedPeriods(state, periods) {
      state.historizedPeriods = periods;
    },
    setSelectedContractYear(state, year) {
      state.selectedContractYear = year;
    },
  },
  actions: {
    fetchStatistics({ commit }, { year, month = null }) {
      commit("setLoading", true);
      return kpi
        .getKPIData(year, month)
        .then((response) => {
          commit("setLoading", false);
          const averageCost = {
            text: "average-cost",
            value: response.data.averageCost,
            type: "price",
          };
          const totalSubFranchises = {
            text: "total-sub-franchises",
            value: response.data.totalSubFranchises,
            type: "number",
          };
          const totalOrdersLastYear = {
            text: "total-orders",
            value: response.data.totalOrdersLastYear,
            type: "number",
          };
          const totalPointsSpentLastYear = {
            text: "total-points-spent",
            value: response.data.totalPointsSpentLastYear,
            type: "price",
          };
          const totalCAPoint = {
            text: "total-ca-point",
            value: response.data.totalCaPoint,
            type: "price",
          };
          const totalCA = {
            text: "total-ca",
            value: response.data.totalCA,
            type: "price",
          };
          const totalContract = {
            text: "total-contract",
            value: response.data.totalContract,
            type: "number",
          };
          const estimatedPoints = {
            text: "estimated-points",
            value: response.data.estimatedPoints,
            type: "number",
          };
          const estimatedPrice = {
            text: "estimated-price",
            value: response.data.estimatedPrice,
            type: "price",
          };
          const estimatedGrowth = {
            text: "estimated-growth",
            value: response.data.estimatedGrowth,
            type: "number",
          };
          const estimatedGrowthEuro = {
            text: "estimated-growth-euro",
            value: response.data.estimatedGrowthEuro,
            type: "price",
          };
          const totalMargin = {
            text: "total-margin",
            value: response.data.totalMargin,
            type: "number",
          };
          const totalMarginPoint = {
            text: "total-margin-point",
            value: response.data.totalMarginPoint,
            type: "number",
          };
          const roi = {
            text: "roi",
            value: response.data.roi,
            type: "number",
          };

          const statisTicsFirstPart = [
            averageCost,
            totalSubFranchises,
            totalOrdersLastYear,
            totalPointsSpentLastYear,
            totalMarginPoint,
            estimatedPrice,
          ];

          const statisTicsSecondPart = [
            totalCA,
            totalCAPoint,
            totalContract,
            estimatedPoints,
            estimatedGrowth,
            estimatedGrowthEuro,
            totalMargin,
            roi,
          ];

          commit("setStatistics", statisTicsFirstPart);
          commit("setStatisticsSecondPart", statisTicsSecondPart);
          return response.data;
        })
        .catch((error) => {
          commit("setLoading", false);
          throw error;
        });
    },
    fetchFranchiseStatistics({ commit }, { year, month = null }) {
      commit("setLoading", true);
      return kpi
        .getKPIFranchiseData(year, month)
        .then((response) => {
          commit("setLoading", false);
          const statisticsItems = response.data;
          commit("setStatisticsItems", statisticsItems);
          return statisticsItems;
        })
        .catch((error) => {
          commit("setLoading", false);
          throw error;
        });
    },
    fetchCustomersStatistics({ commit }, { year, month = null }) {
      commit("setLoading", true);
      return kpi
        .getKPICustomerData(year, month)
        .then((response) => {
          commit("setLoading", false);
          const customersStatistics = response.data;
          commit("setCustomersStatistics", customersStatistics);
          return customersStatistics;
        })
        .catch((error) => {
          commit("setLoading", false);
          throw error;
        });
    },
    fetchOrderOneStrykerStatistics({ commit }, data) {
      commit("setLoading", true);
      return kpi
        .getOrderOneStrykerKPIData(data)
        .then((response) => {
          commit("setLoading", false);
          const orderOneStrykerItems = response.data;
          commit("setOrderOneStrykerItems", orderOneStrykerItems);
          return response;
        })
        .catch((error) => {
          commit("setLoading", false);
          throw error;
        });
    },
    fetchConfiguration({ commit }, { year = null, month = null } = {}) {
      // Réinitialiser les items avant de charger les nouvelles données
      commit("setConfigurationItems", []);
      commit("setLoading", true);
      return kpi
        .getKPIConfiguration(
          ["ManualCogs", "CalculatedCogs", "UseCalculatedCogs"],
          year,
          month,
        )
        .then((response) => {
          commit("setLoading", false);
          const items = response.data;
          commit("setConfigurationItems", items);
          return items;
        })
        .catch((error) => {
          commit("setLoading", false);
          throw error;
        });
    },
    fetchKPIProvisions({ commit, dispatch }, { year, month = null }) {
      commit("setLoading", true);
      return kpi
        .getKPIProvisionData(year, month)
        .then((response) => {
          commit("setLoading", false);
          const provisions = response.data.franchises;
          const totalProjectedPoints = response.data.totalPointsProjected;
          commit("setProvisionsItems", provisions);
          commit("setTotalProjectedPoints", totalProjectedPoints);
          dispatch("fetchConfiguration", { year, month });
          return response.data;
        })
        .catch((error) => {
          commit("setLoading", false);
          throw error;
        });
    },
    fetchGimCustoms({ commit }) {
      commit("setLoading", true);
      return kpi
        .getGimCustomsDistribution()
        .then((response) => {
          commit("setLoading", false);
          const items = response.data;
          commit("setGimCustomDistributionItems", items);
          return items;
        })
        .catch((error) => {
          commit("setLoading", false);
          throw error;
        });
    },
    fetchKPICommissions({ commit }, year = null) {
      commit("setLoading", true);
      return kpi
        .getKPICommissions(year)
        .then((response) => {
          commit("setLoading", false);
          const items = response.data;
          commit("setCommissions", items);
          return items;
        })
        .catch((error) => {
          commit("setLoading", false);
          throw error;
        });
    },
    exportExcelOrderOne({ commit }, data) {
      return kpi.exportExcelOrderOne(data).then((response) => {
        commit("setLoading", false);
        return response;
      });
    },
    exportExcelCommissions({ commit }, year = null) {
      return kpi.exportExcelCommissions(year).then((response) => {
        commit("setLoading", false);
        return response;
      });
    },
    exportExcelFranchise({ commit }, { year, month = null }) {
      return kpi.exportExcelFranchise(year, month).then((response) => {
        commit("setLoading", false);
        return response;
      });
    },
    exportExcelCustomer({ commit }, { year, month = null }) {
      return kpi.exportExcelCustomer(year, month).then((response) => {
        commit("setLoading", false);
        return response;
      });
    },
    // Actions pour l'historisation
    fetchHistorizedPeriods({ commit }) {
      commit("setLoading", true);
      return kpiHistory
        .getHistorizedPeriods()
        .then((response) => {
          commit("setLoading", false);
          commit("setHistorizedPeriods", response.data);
          return response.data;
        })
        .catch((error) => {
          commit("setLoading", false);
          throw error;
        });
    },
    generateMonthlySnapshot({ commit }, { year, month }) {
      commit("setLoading", true);
      return kpiHistory
        .generateMonthlySnapshot(year, month)
        .then((response) => {
          commit("setLoading", false);
          return response.data;
        })
        .catch((error) => {
          commit("setLoading", false);
          throw error;
        });
    },
    generateAnnualSnapshot({ commit }, year) {
      commit("setLoading", true);
      return kpiHistory
        .generateAnnualSnapshot(year)
        .then((response) => {
          commit("setLoading", false);
          return response.data;
        })
        .catch((error) => {
          commit("setLoading", false);
          throw error;
        });
    },
    generateRetroactiveHistory(
      { commit },
      { startYear, startMonth, endYear, endMonth },
    ) {
      commit("setLoading", true);
      return kpiHistory
        .generateRetroactiveHistory(startYear, startMonth, endYear, endMonth)
        .then((response) => {
          commit("setLoading", false);
          return response.data;
        })
        .catch((error) => {
          commit("setLoading", false);
          throw error;
        });
    },
    deleteSnapshot({ commit }, { year, month = null }) {
      commit("setLoading", true);
      return kpiHistory
        .deleteSnapshot(year, month)
        .then((response) => {
          commit("setLoading", false);
          return response;
        })
        .catch((error) => {
          commit("setLoading", false);
          throw error;
        });
    },
    validateSnapshot({ commit }, { year, month = null }) {
      commit("setLoading", true);
      return kpiHistory
        .validateSnapshot(year, month)
        .then((response) => {
          commit("setLoading", false);
          return response.data;
        })
        .catch((error) => {
          commit("setLoading", false);
          throw error;
        });
    },
    updateManualCogs({ commit, dispatch }, data) {
      commit("setLoading", true);
      return kpi
        .updateManualCogs(data)
        .then((response) => {
          commit("setLoading", false);
          const items = response.data;
          dispatch("fetchConfiguration");
          return items;
        })
        .catch((error) => {
          commit("setLoading", false);
          throw error;
        });
    },
    updateUseCurrentYearOrNot({ commit, dispatch }, value) {
      commit("setLoading", true);
      return kpi
        .updateKpiData(value)
        .then((response) => {
          commit("setLoading", false);
          const items = response.data;
          dispatch("fetchConfiguration");
          return items;
        })
        .catch((error) => {
          commit("setLoading", false);
          throw error;
        });
    },
    /**
     * Exporte les provisions en PDF avec données pré-calculées
     * @param {Object} provisionData - Données des provisions (ProvisionExportDto)
     * @returns {Promise} Réponse contenant le blob PDF
     */
    exportProvisionsToPdf({ commit }, provisionData) {
      commit("setLoading", true);
      return kpi
        .exportProvisionsToPdf(provisionData)
        .then((response) => {
          commit("setLoading", false);
          return response;
        })
        .catch((error) => {
          commit("setLoading", false);
          throw error;
        });
    },
  },
};
